import type { Channel, ProtoItem} from "@ca.vmedia.tv/domains";
import { ChannelLiveCardData } from "@/components/Cards/types";
import { useFavoriteChannelsStore } from "@/stores/FavoriteChannels";
import { Logger } from '@/utils';
import type { AxiosError } from "axios";
import type { ExposeInterface } from './types';

export const useShowAllMyTvChannelsStore = defineStore('ShowAllMyTvChannels', (): ExposeInterface => {
    const FavoriteChannelsStoreModule = useFavoriteChannelsStore();
    const {
        getFavoriteChannels
    } = storeToRefs(FavoriteChannelsStoreModule);

    const { fetchFavoriteChannels, fetchFavoriteChannelsNextPage, clearSoft } = FavoriteChannelsStoreModule;


    const _favoritesChannelsItems = computed((): ProtoItem[] => getFavoriteChannels.value?.items ?? []);
    const getCardsChannels = computed((): ChannelLiveCardData[] => _favoritesChannelsItems.value.map((item) => new ChannelLiveCardData(item as unknown as Channel)));

    const _isFavoritesChannelsLoading: Ref<boolean> = ref(false);
    const getIsFavoritesChannelsLoading = computed((): boolean => _isFavoritesChannelsLoading.value);

    const loadFavoritesChannels = async (): Promise<void> => {
        try {
            _isFavoritesChannelsLoading.value = true;
            await fetchFavoriteChannels();
        } catch (error) {
            Logger.captureError(error as AxiosError | Error);
        } finally {
            _isFavoritesChannelsLoading.value = false;
        }
    };
    const loadFavoritesChannelsNextPage = async (): Promise<void> => {
        if(_isFavoritesChannelsLoading.value === true 
            || !getFavoriteChannels.value?.paging?.pageNumber
            || !getFavoriteChannels.value?.paging?.totalPages
            || (getFavoriteChannels.value.paging.pageNumber >= getFavoriteChannels.value.paging.totalPages)){
            return;
        }

        try {
            _isFavoritesChannelsLoading.value = true;
            await fetchFavoriteChannelsNextPage();
        } catch (error) {
            Logger.captureError(error as AxiosError | Error);
        } finally {
            _isFavoritesChannelsLoading.value = false;
        }
    };

    const clearAll = (): void => {
        clearSoft();
    };


    return {
        getCardsChannels,
        getIsFavoritesChannelsLoading,
        loadFavoritesChannels,
        loadFavoritesChannelsNextPage,
        clearAll
    };
});
